module.exports = __webpack_public_path__ + "static/media/TOTAL-SCORE-1.20835e86.png";